/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PersonalInformation
 */
export interface PersonalInformation {
    /**
     * 
     * @type {string}
     * @memberof PersonalInformation
     */
    gender?: PersonalInformationGenderEnum;
    /**
     * 
     * @type {Date}
     * @memberof PersonalInformation
     */
    birthDate?: Date;
}


/**
 * @export
 */
export const PersonalInformationGenderEnum = {
    Undefined: 'UNDEFINED',
    Man: 'MAN',
    Woman: 'WOMAN',
    Other: 'OTHER'
} as const;
export type PersonalInformationGenderEnum = typeof PersonalInformationGenderEnum[keyof typeof PersonalInformationGenderEnum];


/**
 * Check if a given object implements the PersonalInformation interface.
 */
export function instanceOfPersonalInformation(value: object): value is PersonalInformation {
    return true;
}

export function PersonalInformationFromJSON(json: any): PersonalInformation {
    return PersonalInformationFromJSONTyped(json, false);
}

export function PersonalInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalInformation {
    if (json == null) {
        return json;
    }
    return {
        
        'gender': json['gender'] == null ? undefined : json['gender'],
        'birthDate': json['birthDate'] == null ? undefined : (new Date(json['birthDate'])),
    };
}

export function PersonalInformationToJSON(value?: PersonalInformation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'gender': value['gender'],
        'birthDate': value['birthDate'] == null ? undefined : ((value['birthDate']).toISOString().substring(0,10)),
    };
}

